import React from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../Context/AuthContext'
import AppSideNav from './AppSideNav'
import { getPageBackground, hasAppSideNav } from '../lib/sideNavConfig'

// Persistent app-shell wrapper: mounted once at the App root (wrapping all of
// <Routes>) so AppSideNav never unmounts/remounts between pages. Whether the
// sidebar and its background actually show up is decided per-page via
// hasAppSideNav/getPageBackground (see src/lib/sideNavConfig.js) rather than
// by whether this component itself is mounted.
//
// The background is applied here (spanning both the sidebar and the content
// column) rather than inside the page itself, so the sticky sidebar and the
// scrolling page always show the exact same background instead of looking
// like two visually separate panels. It's only applied on sidebar-eligible
// routes so the other pages (each with their own background/min-h-screen)
// are completely unaffected.
//
// Some sidebar routes (e.g. /courses) are publicly browsable, so the sidebar
// itself only renders for signed-in users — guests see the page unchanged.
export default function AppSideNavLayout({ children }) {
  const location = useLocation()
  const { user } = useAuth()
  const isRouteEligible = hasAppSideNav(location.pathname)
  const background = isRouteEligible ? getPageBackground(location.pathname) : undefined

  return (
    // The fixed navbar is compensated by a spacer of --app-navbar-height above this layout (App.jsx), and the phone
    // bottom nav by the shell's bottom padding, so a full 100vh here made every page scroll by that much.
    <div
      className="relative flex w-full items-start"
      style={{ background, minHeight: 'calc(100dvh - var(--app-navbar-height, 0px) - var(--app-mobile-bottom-nav-height, 0px))' }}
    >
      {user && <AppSideNav />}
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  )
}
